import { isArray, isString } from 'remeda';
var LENGTH_ZERO = 0;
var isEmpty = function (input) {
    if (isArray(input) || isString(input)) {
        return input.length === LENGTH_ZERO;
    }
    return Object.keys(input).length === LENGTH_ZERO;
};
export default isEmpty;
